import React, { useState, useEffect, useMemo, useCallback, memo, useContext, useRef } from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, IconButton, Box, Chip,
  FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput,
  Alert, AlertTitle, Tooltip,
} from '@mui/material';

import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { ThresholdDisplay, BadgeCountDisplay, ThresholdCheckBox, ColumnSorting } from './helper-components';
import { getEffectedDates, resetBucketsData, changeBucketsUserAction, cleanBucketsData } from './functions';

import RoomFilterMenu from './RoomFilterMenu';
import NotesPopup from '.././NotesPopup';
import EventsPopup from '.././EventsPopup';
import { getPermissions, getSeriesById, dateFormat, deepCopy, getYearsRange, clearAPIRegistryDataByKey } from '../../../app/util';
import { RowDataContext, RowDataProvider, RestrictionsMainDataContext, RestrictionsMainDataProvider, RowStateProvider, RowStateContext, RestrictionsStateProvider, RestrictionsStateContext, } from './contexts';

import { getRoomDetailsFromMap, getUniqueRoomClasses, groupRoomTypesByClass } from '../../../app/productService';
import icons from './svgIcons';
import initialData from './restriction-data.json';
// import bucketData from './bucket-data.json';
// import initialData from './sample-data.js';

import { apiListAndData } from "../../../app/apiListAndData";

import moment from 'moment';

import SendRestrictionsProductModal from '../../Modal/SendRestrictionsProductModal';
import { callApiDirect, useFetchApi } from '../../../hooks/useFetchApi';

import BucketDetailsTable from './components/BucketDetailsTable';
import Filter from "../Filter";
import { BorderRight } from '@mui/icons-material';
import analytics from '../../../app/analytics-config';
import VCapIndicator from '../VCapIndicator';
const stickyStyle1 = {
  position: 'sticky',
  top: 0,
  zIndex: 10,
};

const stickyStyle2 = {
  position: 'sticky',
  //top: 38,
  zIndex: 10,
};

const cellStyle = {
  //border: '0.5px solid #ccc',
  padding: '8px 8px',
  textAlign: 'center',
  textWrap: "nowrap"
};

const cellStyleHeader = {
  //border: '0.5px solid #EBEBEB',
  borderRight: '1px solid #EBEBEB',
  padding: '6px 8px',
  textAlign: 'center',
  textWrap: "nowrap"
};


const TableRestrictionsProduct = () => {
  const { app_state, ui_state } = useSelector((state) => state.app.current_state);
  const { plrFeatures, primary_stay_range } = app_state;

  let initialTableData = getSeriesById("GetRestrictionsProduct")?.data?.data;
  let { as_of_date } = primary_stay_range;

  initialTableData = initialTableData?.filter(item => moment(item.date).diff(as_of_date, 'days') >= 0)
  const dates = [];
  const updatedData = initialTableData?.map((dateItem) => {
    dates.push(dateItem.date);
    return {
      ...dateItem,
      buckets: dateItem.buckets || []
    };
  });
  const sampleData = initialData;
  let [dataDates, setDataDates] = useState(dates);
  const [masterData, setMasterData] = useState(updatedData);
  const [roomNameEle, setRoomNameEle] = React.useState({ id: null, toolTipVisible: false });

  // const { auth } = useSelector(appState => appState);
  const { property_details } = useSelector(state => state.auth.profile);
  const { permissions, index } = getPermissions(property_details, app_state.property_id);
  const { currency_symbol } = ui_state;
  const visibleDOWTitle = ui_state.table_filters.table_common.dow.map(item => item.title);
  const roomSubHeaders = ['Room Sold', 'Available'];
  const [selectedBuckets, setSelectedBuckets] = useState({});
  const [selectedRatePlans, setSelectedRatePlans] = useState({});
  const dispatch = useDispatch();

  const room_settings = app_state.room_settings;
  let startDate = app_state.primary_stay_range.date_from;
  let endDate = app_state.primary_stay_range.date_until;
  const [cols, setCols] = useState([
    { type: "date", filterable: false, sorted: null },
    { type: "dow", filterable: true, sorted: null },
  ])

  const onOrderByChangeHandler = (item) => {
    if (!['active', 'processing'].includes(app_state.plrRowCalcStatus)) {
      const forUpdate = deepCopy(cols)
      forUpdate.map((col) => {
        if (col.type === item.type) {
          col.sorted = item.sorted;
        } else {
          col.sorted = null;
        }
      })
      setCols(forUpdate);
      console.log('cols', cols);
    };
  }

  const roomMap = useMemo(() => {
    return room_settings?.reduce((acc, room) => {
      acc[room.room_code] = room;
      return acc;
    }, {});
  }, [room_settings]);

  let baseRoom = ''
  let baseClass = ''

  const roomTypesGroupByClassInitial = room_settings.reduce((acc, { room_class, room_code, is_base }) => {
    if (is_base) {
      baseRoom = room_code
      baseClass = room_class
    }
    if (!acc[room_class]) {
      acc[room_class] = {};
      acc[room_class]['all'] = [];
      acc[room_class]['selected'] = [];
    }
    acc[room_class].all.push(room_code);
    acc[room_class].selected.push(room_code);
    return acc;
  }, {});

  const [roomTypesGroupByClass, setRoomTypesGroupByClass] = useState(
    roomTypesGroupByClassInitial
  )

  const allRoomClasses = getUniqueRoomClasses(room_settings)
  const roomTypesByClass = groupRoomTypesByClass(room_settings);
  // const [selectedRoomClass, setSelectedRoomClass] = useState(allRoomClasses);
  const [selectedRoomTypes, setSelectedRoomTypes] = useState(allRoomClasses.flatMap(cls => roomTypesByClass[cls] || []));

  useEffect(() => {
    let cartDates = getSeriesById("GetRestrictionsProduct")?.data?.cart_dates || [];
    let newCartDates = [];
    //Remove past date if exiting in cart
    let payloadData = { 'stayDates': [] }
    cartDates.forEach(d => {
      const isPastDate = moment(d).isBefore(moment().format("YYYY-MM-DD"));
      if (isPastDate) {
        payloadData.stayDates.push(d);
      } else {
        newCartDates.push(d);
      }
    });
    // let payload = { "asOfDate": app_state?.as_of_date, data: payloadData, actionType: 'date_remove' };
    // callApiDirect(app_state, "singleDateDelete", payload, 'PUT');

    dispatch({
      type: "UPDATE_STATE",
      payload: {
        app_state: {
          plrDatesToPush: newCartDates,
          plrFeatures: {
            thresholdRec: Boolean(permissions?.restrictions_recommendation),
            restrictionsRec: Boolean(permissions?.restrictions_recommendation)
          }
        }
      }
    });
    //Cleaning up
    return (() => {
      clearAPIRegistryDataByKey('GetRestrictionsProduct');
      const apiKeys = Object.keys(apiListAndData);
      apiKeys.forEach((k) => {
        apiListAndData[k].data = {};
      })

      //Reset recalculate status
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrRowCalcStatus: 'done',
          }
        }
      });
    });
  }, [])

  const handleClose = () => {
    setRoomNameEle({ id: null, toolTipVisible: false });
  };

  const handleOpen = (index) => {
    const elements = document.querySelectorAll('.room-name');
    const el = elements[index];
    if (isEllipsed(el)) {
      el['showTitle'] = true;
    } else {
      el['showTitle'] = false;
    }
    setRoomNameEle({ id: index, toolTipVisible: el['showTitle'] });
  };

  const [dynamicTop, setDynamicTop] = useState("38px");
  const [dynamicLeft, setDynamicLeft] = useState("193px");

  useEffect(() => {
    // Function to return current browser zoom
    function getZoomLevel() {
      return Math.round((window.devicePixelRatio / 2) * 100);
    }

    let currentZoom = getZoomLevel();

    const handler = () => {
      const newZoom = getZoomLevel();

      if (newZoom !== currentZoom) {
        currentZoom = newZoom;

        if (newZoom < 100) {
          if (newZoom > 80) {
            setDynamicTop("37.5px");
          }
          else {
            setDynamicTop("38px");
          }
          setDynamicLeft("192.8px");
        }
      }
    };

    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  function isEllipsed(element) {
    return element.scrollWidth > element.clientWidth;
  }
  if (!initialTableData || initialTableData?.length <= 0) {
    return (<Box sx={{ p: 1 }}>
      <Alert severity="info" >
        <AlertTitle>Info </AlertTitle>
        Data is not available for the selected As Of Date or selected date range.
      </Alert>
    </Box>)
  }
  if (permissions?.di_version !== 4 && permissions?.restriction_d && permissions?.restriction_d?.restriction_product === false) {
    return (<Box sx={{ p: 1 }}>
      <Alert severity="info" >
        <AlertTitle>Info </AlertTitle>
        Product level restrictions update or control is not yet enabled for {permissions?.restriction_s}
      </Alert>
    </Box >)
  } else {
    return (
      <RestrictionsStateProvider value={{ datesToUpdate: [], thresholdCheckedStatus: null }}>
        <RestrictionsMainDataProvider value={masterData}>
          <TableContainer component={Paper} className="product-restrictions-container" >
            {/* Room filter getting rid from first phase */}
            {/* <RoomFilterMenu
              roomTypesGroupByClass={roomTypesGroupByClass}
              setRoomTypesGroupByClass={setRoomTypesGroupByClass}
              setSelectedRoomTypes={setSelectedRoomTypes}
              baseRoom={baseRoom}
              baseClass={baseClass}
              app_state={app_state}
              ui_state={ui_state}
            /> */}
            {/* <Box className="color-code-legend" id={(window.createUniqueElementId('legend'))}>
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="10" height="10" rx="2" fill="#F9C19B" />
              </svg>
              <div>User Override</div>
            </Box> */}
            <Table stickyHeader className="table-product-restrictions" id={(window.createUniqueElementId('table'))}>
              <TableHead className="table-headers" >
                {/* Primary Header */}
                <TableRow className='primary-header'>
                  <TableCell colSpan={2} style={{ ...cellStyleHeader, ...stickyStyle1, left: "0px", zIndex: 12 }}> {getYearsRange(startDate, endDate)} </TableCell>
                  <TableCell style={{ ...cellStyleHeader, ...stickyStyle1, left: dynamicLeft, zIndex: 12 }}> </TableCell>
                  {
                    selectedRoomTypes.map((type, i) => {
                      const details = getRoomDetailsFromMap(roomMap, type);
                      return (
                        <TableCell
                          className="col-room-type"
                          key={i}
                          colSpan={3}
                          style={{ ...cellStyleHeader, ...stickyStyle1, textAlign: 'center' }}
                        >
                          <Box className="room-code" > {type} </Box>
                          <Box className="room-details">
                            {/* <div style={{ fontSize: 10, color: "gray" }}>Width: {cellWidth}px</div> */}
                            {/* <div className='cap'>Cap: {details?.inventory ?? '-'}</div>
                            <div>|</div> */}
                            <Tooltip title={details?.display_name ?? '-'}
                              slotProps={{
                                popper: {
                                  modifiers: [
                                    {
                                      name: 'offset',
                                      options: {
                                        offset: [0, -14],
                                      },
                                    },
                                  ],
                                },
                              }}
                              open={roomNameEle.id === i && roomNameEle.toolTipVisible}
                              onClose={() => handleClose()}
                              onOpen={() => handleOpen(i)}
                              arrow>
                              <div className='room-name'>Cap: {details?.inventory ?? '-'} | {details?.display_name ?? '-'}</div>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      );
                    })}
                </TableRow>

                {/* Secondary Header */}
                <TableRow className='secondary-header' >
                  <TableCell className='col-date' rowSpan={2} style={{ ...cellStyleHeader, ...stickyStyle2, top: dynamicTop, left: "0px", zIndex: 12 }}>
                    <Box className="date-cell" >
                      <ColumnSorting
                        label="Date"
                        colItem={cols[0]}
                        sorted={cols[0].sorted}
                        onOrderByChange={onOrderByChangeHandler} />
                      <Box sx={{ ml: 1 }}> Date </Box>
                    </Box>
                  </TableCell>
                  <TableCell className='col-dow' rowSpan={2} style={{ ...cellStyleHeader, ...stickyStyle2, top: dynamicTop, left: "100px", zIndex: 12 }}>
                    <Box className="dow-cell" >
                      <ColumnSorting
                        label="DOW"
                        colItem={cols[1]}
                        sorted={cols[1].sorted}
                        onOrderByChange={onOrderByChangeHandler} />
                      <Box> DOW  </Box>
                      <Box className="filter-container">
                        {visibleDOWTitle.length < 7 && <span className={'has-filter'}></span>}
                        <Filter
                          currentColumn={cols[1]}
                          columnList={[]}
                          applyFilterHandler={() => { }}
                        />
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell className='col-threshold' style={{ ...cellStyleHeader, ...stickyStyle2, top: dynamicTop, left: dynamicLeft, zIndex: 12 }}> Threshold({currency_symbol})
                    {plrFeatures.thresholdRec && <ThresholdCheckBox />}
                  </TableCell>
                  {
                    selectedRoomTypes.map(() =>
                      roomSubHeaders.map((sub, j) => (
                        <TableCell colSpan={sub === "Room Sold" ? 2 : 1} key={j} style={{ ...cellStyleHeader, ...stickyStyle2, top: dynamicTop, }}>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span>{sub}</span>
                            {sub === 'Available' && permissions?.variable_capacity_enabled && (
                              <span style={{
                                fontSize: '9.5px', fontWeight: 600, letterSpacing: '0.5px',
                                textTransform: 'uppercase', color: '#FFD873', lineHeight: 1, whiteSpace: 'nowrap',
                              }}>•OOO/OOS</span>
                            )}
                          </div>
                        </TableCell>
                      ))
                    )}
                </TableRow>
              </TableHead>

              <TableBody className='table-body'>

                <RowStateProvider value={{ prevActiveRow: null, activeRow: null }}>
                  <RestrictionsMainDataRows dataDates={dataDates} cols={cols} masterData={masterData} selectedRoomTypes={selectedRoomTypes} currency_symbol={currency_symbol} visibleDOWTitle={visibleDOWTitle} />
                </RowStateProvider>

              </TableBody>
            </Table>
          </TableContainer>
        </RestrictionsMainDataProvider>
      </RestrictionsStateProvider>
    );
  }
};

export default TableRestrictionsProduct;

const RestrictionsMainDataRows = ({ selectedRoomTypes, currency_symbol, visibleDOWTitle, cols }) => {
  let restrictionsState = useContext(RestrictionsStateContext);
  let mainDataSet = useContext(RestrictionsMainDataContext);
  // let mainData = mainDataSet.data;
  const dispatch = useDispatch();
  let [mainData, setMainData] = useState(mainDataSet.data);
  const { app_state, ui_state } = useSelector((state) => state.app.current_state);
  const getPlrRowCalcStatus = () => {
    return app_state.plrRowCalcStatus;
  }

  const onClickOutside = (e) => {
    e.stopPropagation();
    let isRestrictionsOverridden = mainData.find(itm => itm.isRestrictionsOverridden);

    if (!e.target.closest('.popup-modal-wrap')
      && !e.target.closest('.level-two-header')
      && !e.target.closest('.level-two-row')
      && !e.target.closest('.level-three-row')
      && !e.target.closest('.threshold-container')
      && app_state.plrRowCalcStatus === 'active'
    ) {
      // restrictionsState.state.thresholdRecalc = moment().format('x');
      // restrictionsState.updateState({ thresholdRecalc: moment().format('x') });
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrRowCalcStatus: 'processing',
          }
        }
      });
      // restrictionsState.updateState({ thresholdRecalc: moment().format('x'), recalcStatus: { date: recalcStatus.date, status: 'processing' } });

    }
  }

  useEffect(() => {
    document.removeEventListener('click', onClickOutside);
    document.addEventListener('click', onClickOutside);

    return () => {
      // Cleanup if needed when component unmounts
      document.removeEventListener('click', onClickOutside);
    }
  }, [app_state.plrRowCalcStatus]);

  useEffect(() => {

    // if (!['active', 'processing'].includes(app_state.plrRowCalcStatus)) {

    let item = cols.find(col => {
      if (col.sorted !== null) {
        return col
      }
    });

    if (!item) {
      item = cols[0];
    }

    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    // if (restrictionsState.state.activeRow) {

    //   const activeIndex = mainDataSet.data.findIndex(d => d.date === restrictionsState.state.activeRow);
    //   mainDataSet.data[activeIndex].details_open = false;
    //   mainDataSet.data[activeIndex].thresholdRecalc = false;
    //   mainDataSet.data[activeIndex].recalculating = false;
    //   mainDataSet.data[activeIndex].isRestrictionsOverridden = false;
    //   // restrictionsState.updateState({ activeRow: null });
    // }

    let sortedData = deepCopy(mainDataSet.data);
    // mainDataSet.updateData([]);
    let itemCopy = deepCopy(item);
    itemCopy.sorted = item.sorted === null ? 'asc' : item.sorted;
    itemCopy.type = item.sorted === null ? 'date' : item.type;

    if (itemCopy.type === 'dow') {
      sortedData.sort((a, b) => {
        if (day.indexOf(a[itemCopy.type]) < day.indexOf(b[itemCopy.type])) {
          return itemCopy.sorted === 'asc' ? -1 : 1;
        }
        if (day.indexOf(a[itemCopy.type]) > day.indexOf(b[itemCopy.type])) {
          return itemCopy.sorted === 'asc' ? 1 : -1;
        }
        return 0;
      });
    } else {
      sortedData.sort((a, b) => {
        if (a[itemCopy.type] < b[itemCopy.type]) {
          return itemCopy.sorted === 'asc' ? -1 : 1;
        }
        if (a[itemCopy.type] > b[itemCopy.type]) {
          return itemCopy.sorted === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    // setTimeout(() => {
    restrictionsState.updateState({ activeRow: null });
    mainData = sortedData;
    mainDataSet.updateData(sortedData);
    // setMainData(sortedData);

    // }, 0);


  }, [cols]);

  useEffect(() => {

    // let effectedDates = getEffectedDates({ mainData: mainDataSet.data, app_state });
    // dispatch({
    //   type: "UPDATE_STATE",
    //   payload: {
    //     app_state: {
    //       plrDatesToPush: effectedDates,
    //     }
    //   }
    // });
    if (app_state.plrRowCalcStatus === 'done') {
      // if (!app_state.plrDatesToPush.includes(app_state.plrRecalcDate)) {
      //   app_state.plrDatesToPush.push(app_state.plrRecalcDate);
      //   let effectedDates = deepCopy(app_state.plrDatesToPush);
      //   dispatch({
      //     type: "UPDATE_STATE",
      //     payload: {
      //       app_state: {
      //         plrDatesToPush: effectedDates,
      //         plrRecalcDate: null
      //       }
      //     }
      //   });
      // }
    }

  }, [
    restrictionsState.state.thresholdCheckedStatus,
    restrictionsState.state.rowThresholdToggled,
    // restrictionsState.state.rowRestrictionsUpdated
    app_state.plrRowCalcSuccess
  ]);

  useEffect(() => {
    if (restrictionsState.state.datesToUpdate && restrictionsState.state.datesToUpdate.length) {
      restrictionsState.state.datesToUpdate.forEach((item) => {
        const date = moment(item.stay_date).format("YYYY-MM-DD");
        const indexInMainData = mainData.findIndex(itm => itm.date === date);
        mainData[indexInMainData].badge_counts.user_updated = item.badge_counts.user_updated;
        mainData[indexInMainData].threshold.user = item.threshold.user;
        mainData[indexInMainData].buckets = deepCopy(item.buckets);
      })
      // mainData = sortedData;
      mainDataSet.updateData(mainData);
    }
  }, [
    restrictionsState.state.datesToUpdate
  ]);

  return (
    <>
      {
        mainDataSet.data.map((dateObj, index) => {
          const date = dateObj.date;
          // const dow = dateObj.dow;
          // const details_open = dateObj.details_open;
          // const badge_counts = dateObj.badge_counts;
          // const threshold = dateObj.threshold;
          // const rooms_summary = dateObj.rooms_summary;
          // const buckets = dateObj.buckets;

          return (
            <RowDataProvider value={dateObj}>
              <React.Fragment key={date}>
                {/* Level 1 Data Rows */}
                {dateObj && <MainDateRow key={'mainRow_' + date} visibleDOWTitle={visibleDOWTitle} index={index} selectedRoomTypes={selectedRoomTypes} currency_symbol={currency_symbol} />}

                {/* Level 2 Header Row */}

              </React.Fragment>
            </RowDataProvider>

          );
        })}
    </>
  )
};

const MainDateRow = ({ index, visibleDOWTitle, selectedRoomTypes, currency_symbol }) => {

  const appState = useSelector((state) => state);
  const { current_property_date } = appState?.auth?.profile;
  const { app_state } = appState?.app?.current_state;
  const { plrFeatures, as_of_date } = app_state;

  const rowData = useContext(RowDataContext);
  const rowState = useContext(RestrictionsStateContext);
  // 
  const data = rowData.data;
  const dateObj = data;
  const { date, dow, details_open, badge_counts, threshold, rooms_summary } = data;

  // const [dateObj, setDataObj] = useState(data);
  const [thresholdAccepted, setThresholdAccepted] = useState(threshold.curr_user_action === 'recommended_accepted' ? true : false);
  const dispatch = useDispatch();


  // const formatDate = useCallback(function formatDate(date) {
  //   const formattedDate = new Date(date).toLocaleDateString('en-US', {
  //     month: 'short',
  //     day: '2-digit'
  //   });
  //   return formattedDate;
  // });

  const updateThresold = useCallback((newThresold) => {
    data.threshold.recommended_accepted = newThresold.recommended_accepted;
    setThresholdAccepted(newThresold.recommended_accepted);
    data.rooms_summary[0].sold += 1;
    rowData.updatedData(rowData.data);
    // setDataObj(() => {
    //   return { ...data }
    // });;
  });

  useEffect(() => {

    if (app_state?.plrCartUpdate?.axn === "single_date_push" && app_state?.plrCartUpdate?.data?.date === date && app_state?.plrCartUpdate?.data?.dateData) {
      // rowData.data = deepCopy(app_state?.plrCartUpdate?.data);
      let { threshold, badge_counts, buckets } = app_state?.plrCartUpdate?.data?.dateData;
      let newBuckets = [];
      if (rowData && rowData.data && rowData.data.buckets && rowData.data.buckets.length) {
        newBuckets = changeBucketsUserAction(rowData.data.buckets, threshold.pre_user_action);
        rowData.data.buckets = cleanBucketsData(buckets);
      }
      rowData.updateRowData({
        badge_counts: badge_counts,
        threshold: threshold,
        buckets: rowData.data.buckets
      });

      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrCartUpdate: {
              axn: "",
              data: null
            }
          }
        }
      });
    }

    if (app_state?.plrCartUpdate?.axn === "fullCartPushed") {
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            data_load: true,
            plrCartUpdate: {
              axn: "",
              data: null
            }
          },
          ui_state: {
            sendRestrictionsModalOpen: false,
            showspinner: true,
          }
        }
      });
    }

    if (app_state?.plrCartUpdate?.axn === "date_remove" && app_state?.plrCartUpdate?.data?.date === date) {
      rowData.data.threshold.user = rowData.data.threshold.current;
      rowData.data.threshold.curr_user_action = "";
      rowData.data.badge_counts.user_updated = rowData.data.badge_counts.initial;

      if (rowData.data.buckets && rowData.data.buckets.length) {
        rowData.data.buckets = resetBucketsData(rowData.data.buckets);
        rowData.updateRowData({ buckets: rowData.data.buckets });
      }

      rowData.updateRowData({
        rowUpdated: moment().format("x"),
        threshold: deepCopy(rowData.data.threshold),
        badge_counts: deepCopy(rowData.data.badge_counts)
      });

      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrCartUpdate: {
              axn: "",
              data: null
            }
          }
        }
      });
    }

    if (app_state?.plrCartUpdate?.axn === "rateplan_remove" && app_state?.plrCartUpdate?.data?.date === date) {
      const dateString = app_state?.plrCartUpdate?.data?.dateData?.date ?? "";
      const bucketLabel = app_state?.plrCartUpdate?.data?.bucketData?.label ?? "";
      const ratePlanCode = app_state?.plrCartUpdate?.data?.ratePlanDetailData?.label ?? "";
      let rowDataBucket = null;
      let rowDataRatePlanDetails = null;
      if (rowData.data.buckets.length > 0) {
        rowDataBucket = rowData.data.buckets.find((bucket) => bucket.label === bucketLabel);
        rowDataRatePlanDetails = rowDataBucket.rate_plans.find((ratePlan) => ratePlan.rate_plan_code === ratePlanCode);
      }

      if (rowDataBucket) {
        rowDataBucket.badge_count = app_state?.plrCartUpdate?.data?.bucketData?.badge_count;
      }

      if (rowDataRatePlanDetails) {
        rowDataRatePlanDetails.curr_user_action = "";
        if (rowDataRatePlanDetails.rooms_summary.length > 0) {
          rowDataRatePlanDetails.rooms_summary.forEach((roomSummary) => {
            roomSummary.curr_user_action = "";
          })
        }
      }

      rowData.data.threshold.curr_user_action = `${dateString}_${bucketLabel}_${ratePlanCode}__overridden`;
      rowData.data.threshold.user = app_state?.plrCartUpdate?.data?.dateData?.threshold?.current;
      rowData.data.badge_counts.user_updated = app_state?.plrCartUpdate?.data?.dateData?.badge_count;
      rowData.updateRowData(rowData.data);

      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrCartUpdate: {
              axn: "",
              data: null
            }
          }
        }
      });
    }

  }, [app_state?.plrCartUpdate?.axn])

  const [dynamicLeft, setDynamicLeft] = useState("193px");

  useEffect(() => {
    // Function to return current browser zoom
    function getZoomLevel() {
      return Math.round((window.devicePixelRatio / 2) * 100);
    }

    let currentZoom = getZoomLevel();

    const handler = () => {
      const newZoom = getZoomLevel();

      if (newZoom !== currentZoom) {
        currentZoom = newZoom;

        if (newZoom < 100) {
          setDynamicLeft("192.8px");
        }
      }
    };

    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);


  if (!visibleDOWTitle.includes(dow)) return null;
  
  const isPastDate = moment(date).isBefore(moment().format("YYYY-MM-DD"));
  const isPastAsOfDate = moment(as_of_date).isBefore(current_property_date);

  return (<><TableRow className={`level-one-row ${date === rowState.state.activeRow ? 'openSticky' : ''} ${isPastDate || isPastAsOfDate ? 'past-date-row' : ''} ${index % 2 === 0 ? 'even' : 'odd'}`
  }>
    <TableCell className='col-date' style={{ ...cellStyle }}>
      <Box className="date-cell">
        <NotesPopup params={{ stay_date: date }} />
        <DateDetailsToggle rowIndex={index} date={date} badgeCounts={badge_counts} recAccepted={thresholdAccepted} />
      </Box>
    </TableCell>
    <TableCell className='col-dow' style={cellStyle} >
      <Box className="dow-cell" >
        <EventsPopup params={{ stay_date: date }} />
        <Box> {dow} </Box>
      </Box>
    </TableCell>
    <TableCell className='col-threshold' style={{ ...cellStyle, left: dynamicLeft, }}>
      <ThresholdDisplay key={'threshold-' + date} date={date} data={{ threshold: threshold }} updateStatus={updateThresold} selectedRoomTypes={selectedRoomTypes} />
    </TableCell>
    {/* {selectedRoomTypes.map((roomType, i) => {
      const roomSummary = dateObj.rooms_summary.find(r => r.room_type_code === roomType);
      return(<DateLevelRoomSummaryDisplay roomSummary={roomSummary} />);
      
    })} */}
    <RoomTypeCellDisplay selectedRoomTypes={selectedRoomTypes} dateObj={dateObj} />
  </TableRow>
    {date === rowState.state.activeRow && selectedRoomTypes && <BucketDetailsTable
      // details_open={details_open}
      rowIndex={index}
      selectedRoomTypes={selectedRoomTypes}
      // toggleRate={toggleRate}
      date={date}
      icons={icons}
      currency_symbol={currency_symbol}
      dateObj={dateObj}
      cellStyle={cellStyle}
      cellStyleHeader={cellStyleHeader}
    />}
  </>
  );
};

const DateLevelRoomSummaryDisplay = memo(({ roomSummary, date, roomType, variableCapacityEnabled, showVCap }) => {
  const vCap = roomSummary?.v_capacity;
  const cap = roomSummary?.capacity;
  const effCap = showVCap ? (vCap || cap) : cap;
  const vcapDiffers = !!(vCap && vCap !== cap);
  const vcapLabel = (showVCap && vCap) ? 'Variable Capacity' : 'Capacity';

  return (<React.Fragment>
    <TableCell className='col-sold' colSpan={2} style={cellStyle} >
      {roomSummary?.sold ?? "-"
      }
    </TableCell>
    <TableCell className='col-available' style={{ ...cellStyle, position: 'relative' }} >
      {roomSummary?.available ?? "-"}
      {!!effCap && (
        <VCapIndicator
          vcap={effCap}
          vcapLabel={vcapLabel}
          vcapDiffers={vcapDiffers}
          variableCapacityEnabled={variableCapacityEnabled}
          date={date}
          roomType={roomType}
          hideRevpar
        />
      )}
    </TableCell>
  </React.Fragment>);
});

const RoomTypeCellDisplay = memo(({ selectedRoomTypes, dateObj }) => {
  const { app_state } = useSelector((state) => state.app.current_state);
  const { property_details } = useSelector((state) => state.auth.profile);
  const { permissions } = getPermissions(property_details, app_state.property_id);
  // Product/Room Type data levels have no VCap toggle button (Hotel-level only) — they always
  // behave as VCap-on, same as Room Type Pricing (see processData.js _rtShowVCap).
  const showVCap = !!permissions?.variable_capacity_enabled;

  let cols = [];
  selectedRoomTypes.forEach((roomType, i) => {
    const roomSummary = dateObj.rooms_summary.find(r => r.room_type_code === roomType);
    cols.push(
      <DateLevelRoomSummaryDisplay
        key={roomType}
        roomSummary={roomSummary}
        date={dateObj.date}
        roomType={roomType}
        variableCapacityEnabled={permissions?.variable_capacity_enabled}
        showVCap={showVCap}
      />
    );
  });
  return (cols)
})

const DateDetailsToggle = ({ rowIndex, date, recAccepted }) => {
  const { app_state, ui_state } = useSelector((state) => state.app.current_state);
  const mainDataSet = useContext(RestrictionsMainDataContext);
  const rowData = useContext(RowDataContext);
  // const rowState = useContext(RowStateContext);
  const rowState = useContext(RestrictionsStateContext);
  const [detailsOpenStatus, setDetailsOpenStatus] = useState(rowData.data.details_open);
  let badgeCounts = rowData?.data?.badge_counts;

  function onClickHandler() {
    if (rowState.state.activeRow === null) {
      rowState.state.closeRow = null;
      rowState.updateState({ activeRow: date });
      setDetailsOpenStatus(true);
      rowData.data.details_open = true;
      rowData.updateRowData({ details_open: true });
    }

    const { property_id, property_name, workspace_controls, primary_stay_range } = app_state;
    const formatted_stay_date = moment(date).format('YYYY-MM-DD');//dateFormat(moment(), "YYYY-MM-DD");
    window.analyze.track("plr_details_open", {
      "selected_tile": ui_state.active_tiles.join(),
      property_id, property_name,
      pid: app_state.property_id,
      data_level: 'product',
      day_date: formatted_stay_date
    }, {}, {
      app_state: {
        workspace_controls,
      },
      ui_state: {
      }
    });

    if (rowState.state.activeRow && rowState.state.activeRow !== date) {
      rowState.state.closeRow = rowState.state.activeRow;
      rowState.updateState({ closeRow: rowState.state.activeRow, activeRow: date });
      setDetailsOpenStatus(true);
      rowData.data.details_open = true;
      rowData.updateRowData({ details_open: true });
    }
    if (rowState.state.activeRow === date) {
      // rowState.state.activeRow = null;
      rowState.updateState({ activeRow: null });
      setDetailsOpenStatus(false);
      rowData.data.details_open = false;
      rowData.updateRowData({ details_open: false });
    }
  }

  useEffect(() => {
    // if (!rowState.state.activeRow) {
    //   if (rowData.data.details_open) {
    //     rowData.data.details_open = false;
    //     rowData.updateRowData({ details_open: false });
    //     setDetailsOpenStatus(false);
    //   }
    //   // setDetailsOpenStatus(false);
    // }
    if (rowState.state.closeRow && rowState.state.closeRow === date) {
      rowData.data.details_open = false;
      rowData.updateRowData({ details_open: false });
      setDetailsOpenStatus(false);
    }

  }, [rowState.state.closeRow])


  return (
    <>
      <Box sx={{ position: "relative" }} onClick={onClickHandler}>
        <BadgeCountDisplay badgeCounts={badgeCounts} recAccepted={recAccepted} />
        {/* {formatDate(date)} */}
        <div className={`date-text ${rowData.data.processing ? ' animate' : ''}`}>{dateFormat(date, 'MMM DD')}</div>
      </Box>
      <IconButton
        className={`toggle-icon ${detailsOpenStatus ? 'arrow-up' : 'arrow-down'}`}
        size='small'
        onClick={onClickHandler}
        sx={{ p: 0 }}>
        {detailsOpenStatus ? icons.arrowUpIcon : icons.arrowDownIcon}
      </IconButton>
    </>
  )
}